import colorPattern from '../../../colors'

const lightFontColors = {
    'font-primary': colorPattern.onyx,
    'font-secondary': colorPattern.keshi,
    'font-invert': colorPattern.pearl,
    'font-brand-primary': colorPattern.sky,
    'font-brand-secondary': colorPattern.violet,
} as const

export default lightFontColors
